import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Legacy route - admin auth uses the main /login page (AuthShell design).
 */
const AdminLoginPage = () => {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo') || '/admin/dashboard';
  return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
};

export default AdminLoginPage;
